import React from 'react';
import { ChevronLeft } from 'lucide-react';
import './PersonaResultHeader.scss';

function PersonaResultHeader({
  title,
  description,
  onBack,
  backLabel = '목록으로 이동',
  actions = null,
}) {
  return (
    <header className="persona-result-header">
      <button type="button" className="persona-result-header__back" onClick={onBack} aria-label={backLabel}>
        <ChevronLeft size={24} />
      </button>
      <div className="persona-result-header__copy">
        <h1>{title}</h1>
        {description ? <p>{description}</p> : null}
      </div>
      {actions ? <div className="persona-result-header__actions">{actions}</div> : null}
    </header>
  );
}

export default PersonaResultHeader;
